import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IStoreSlice } from "@/redux/slices/store/types";

export const getStoreReviews = createAsyncThunk(
  "store/getStoreReviews",
  async () =>
    await axios({
      method: "GET",
      url: `/api/reviews`,
    }).then((res) => res.data)
);

const pending = (state: IStoreSlice) => {
  state.reviews = {
    loaded: false,
    reviews: {
      average: "5",
      five_start_count: "0",
      total: "5",
      comments: [],
    },
  };
};

const fulfilled = (
  state: IStoreSlice,
  { payload }: { payload: IStoreSlice["reviews"]["reviews"] }
) => {
  state.reviews = {
    loaded: true,
    reviews: payload,
  };
};

export default {
  action: getStoreReviews,
  pending,
  fulfilled,
};
